export const GroupTypes = {
  path: '/group-types',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'groupTypes',
      component: () => import('pages/groupTypes/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.groupTypes.name',
        path: '/group-types',
        condition: 'groupTypes',
      },
    },
    {
      path: 'create',
      name: 'groupTypes-create',
      component: () => import('pages/groupTypes/CreatePage.vue'),
      meta: {
        requiresAuth: true,
        title: 'pageType.create',
        parents: [
          {
            title: 'page.groupTypes.name',
            path: '/group-types',
            condition: 'groupTypes',
          },
        ],
      },
    },
    {
      path: ':id',
      name: 'groupTypes-id',
      component: () => import('src/pages/groupTypes/id/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          {
            title: 'page.groupTypes.name',
            path: '/group-types',
            condition: 'groupTypes',
          },
        ],
      },
    },
    {
      path: ':id/edit',
      name: 'groupTypes-id-edit',
      component: () => import('src/pages/groupTypes/id/EditPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'pageType.edit',
        parents: [
          {
            title: 'page.groupTypes.name',
            path: '/group-types',
            condition: 'groupTypes',
          },
          {
            title: ':name',
            path: '/group-types/:id',
          },
        ],
      },
    },
  ],
};
